import React from 'react';
import { Button, Divider, Form, Input, Layout, Select, Typography } from 'antd';
import classes from './Reset.module.scss';
import { useTranslation } from 'react-i18next';
import { languagesValues } from 'routes/Main/Main';
import LogoType from 'assets/img';

const { Title, Paragraph } = Typography;

const authType = window.REACT_APP_AUTH_TYPE !== 'REPLACE_REACT_APP_AUTH_TYPE' ? window.REACT_APP_AUTH_TYPE : process.env.REACT_APP_AUTH_TYPE; 
const loginAdress = authType === 'blitz' ? 'blitz-auth' : 'login';

type EnterPasswordProps = {
  name: string;
  authData: any;
  checkPassword: (values: {
    password: string;
  }) => Promise<void>;
  isLoading: boolean;
};

const EnterPassword = ({
  name,
  authData,
  checkPassword,
  isLoading,
}: EnterPasswordProps) => {
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  
  const defaultLanguage = localStorage.getItem('language') || 'en';
  
  const onLanguageChange = (value: string) => {
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
  };

  return (
    <div className={classes.mainWrap}>
      <Layout className={classes.subElem}>
        <Select
          className={classes.localizationSelect}
          defaultValue={defaultLanguage}
          onChange={onLanguageChange}
          style={{ minWidth: 130 }}
          options={languagesValues}
          optionLabelProp={'label'}
        />
        <div className={classes.card}>
          <div className={classes.typography}>
            <img src={LogoType} alt='Logotype' className={classes.logo}/>
            <Typography>
              <Title level={3}>{t('checkPassword.title')}</Title>
              <Paragraph className={classes.subTitle}>{t('checkPassword.recoveryTitle', {email: authData.email, name: t(`login.external.btns.${name}`)})}</Paragraph>
            </Typography>
          </div>
          <Form layout='vertical' className={classes.form} onFinish={checkPassword} form={form}>
            <Form.Item
              name={'password'}
              label={t('login.password')}
              rules={[{ required: true, message: t('login.inputPassword') }]}
            >
              <Input.Password
                placeholder={t('login.password')}
                className={classes.input}
              />
            </Form.Item>
            <Form.Item shouldUpdate>
              <Button type='primary' htmlType='submit' loading={isLoading}>
                {t('checkPassword.approve')}
              </Button>
            </Form.Item>
          </Form>
          <Divider />
          <Typography style={{ textAlign: 'center' }}>
            <Typography.Link href={`${loginAdress}`} className={classes.primary}>
              {t('login.returnToLogin')}
            </Typography.Link>
          </Typography>
        </div>
      </Layout>
    </div>
  );
}

export default EnterPassword;
